import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendMutationCreateResourceAccountArgs,
  BackendPerformanceCenterResource,
} from 'src/types/backend';

import { FRAGMENT_RESOURCE } from './schema';

const MUTATION = gql`
  mutation CreateResourceAccount(
    $customerId: ID!
    $name: String!
    $dataSource: String!
    $file: Upload
  ) {
    createResourceAccount(
      customerId: $customerId
      name: $name
      file: $file
      dataSource: $dataSource
    ) {
      ...PerformanceCenterResource
    }
  }
  ${FRAGMENT_RESOURCE}
`;

type Variables = BackendMutationCreateResourceAccountArgs;
type Result = BackendPerformanceCenterResource;

export const createResourceAccount = async (variables: Variables) => {
  const result = await executeGqlMutation({ mutation: MUTATION, variables });
  return getSingleProp<Result>(result.data);
};
